module Meevo.Components.Logging {
  angular.module("meevo.components.logging", []);
}